// Team Foundation strings: app shell, error/404 screens, auth pages.
const foundation = {
  en: {
    "found.loading": "Loading…",
    "found.errorTitle": "Something went wrong",
    "found.errorDesc": "An unexpected error occurred. Reload the page — if the problem continues, contact our support team.",
    "found.reload": "Reload page",
    "found.goHome": "Go to home",
    "found.goBack": "Go back",
    "found.errorDetails": "Technical details",
    "found.notFoundTitle": "This page is off the tracklist",
    "found.notFoundDesc": "The page you're looking for doesn't exist or has been moved.",

    "found.heroEyebrow": "Music distribution",
    "found.heroTitle": "Your music, everywhere.",
    "found.heroSubtitle": "Release on Spotify, Apple Music, YouTube, TikTok and 150+ platforms. Track royalties, build smart links and grow your audience — all in one place.",
    "found.platforms": "150+ platforms",
    "found.terms": "Terms",
    "found.privacy": "Privacy",
    "found.support": "Support",
    "found.rights": "All rights reserved.",
    "found.secure": "Secure, encrypted connection",
    "found.welcomeBack": "Welcome back",
    "found.loginSubtitle": "Sign in to manage your releases and earnings.",
    "found.showPassword": "Show password",
    "found.hidePassword": "Hide password",
    "found.language": "Language",

    "found.createTitle": "Create your account",
    "found.createSubtitle": "Join EAM Music and start releasing in minutes.",
    "found.stepAccount": "Account",
    "found.stepDetails": "Details",
    "found.stepOf": "Step {n} of 2",
    "found.continue": "Continue",
    "found.back": "Back",
    "found.pwWeak": "Weak",
    "found.pwFair": "Fair",
    "found.pwGood": "Good",
    "found.pwStrong": "Strong",
    "found.pwStrength": "Password strength",
    "found.pwHint": "Use 8+ characters with upper & lowercase letters, a number and a symbol.",
    "found.pwTooShort": "Password must be at least 6 characters",
    "found.fillRequired": "Please fill in all required fields",
    "found.invalidEmail": "Please enter a valid email address",
    "found.termsRequired": "Please accept the Terms of Service and Privacy Policy",
    "found.registerSuccess": "Registration successful! Your account is awaiting approval.",
    "found.registerFailed": "Registration failed",
    "found.agreePrefix": "I agree to the",
    "found.termsOfService": "Terms of Service",
    "found.and": "and",
    "found.privacyPolicy": "Privacy Policy",
    "found.addressOptional": "Address (optional)",
    "found.labelNamePh": "Your label name",
    "found.labelDescPh": "Brief description of your label…",
    "found.streetPh": "Street address",
    "found.cityPh": "City",
    "found.countryPh": "Country",
    "found.firstNamePh": "First name",
    "found.lastNamePh": "Last name",
    "found.close": "Close",
    "found.legalTitle": "Terms of Service & Privacy",
    "found.legalIntro": "Summary of the key points. The full agreement is provided with your distribution contract; for questions, contact support@eammusic.net.",
    "found.legal1": "You confirm that you own or control all rights (master, composition, artwork) to the content you distribute through EAM Music.",
    "found.legal2": "Releases are reviewed before delivery. Content that infringes third-party rights, uses artificial streaming or violates store policies may be rejected or taken down.",
    "found.legal3": "Royalties are credited to your account once reported by the stores and can be withdrawn according to the payout terms shown in your dashboard.",
    "found.legal4": "We process your personal data (name, contact, payout and tax details) only to provide the service, meet legal obligations and pay you. We never sell your data.",
    "found.legal5": "You can request a copy or deletion of your data at any time by emailing support@eammusic.net.",

    "found.pendingHello": "Hi {name},",
    "found.pendingHelloAnon": "Hi there,",
    "found.pendingTitle": "Your account is under review",
    "found.pendingDesc": "Thanks for joining EAM Music! An admin needs to approve your account before you can access the portal.",
    "found.pendingNext": "What happens next?",
    "found.pendingStep1": "Our team reviews every application manually.",
    "found.pendingStep2": "You'll receive an email as soon as your account is approved.",
    "found.pendingStep3": "Then you can upload your first release and reach 150+ platforms.",
    "found.checkStatus": "Check status",
    "found.statusApproved": "Your account has been approved!",
    "found.statusRejected": "Your application has been rejected. Please contact support.",
    "found.statusPending": "Your account is still pending approval.",
    "found.statusFailed": "Could not check status",
    "found.logout": "Log out",
  },
  tr: {
    "found.loading": "Yükleniyor…",
    "found.errorTitle": "Bir şeyler ters gitti",
    "found.errorDesc": "Beklenmeyen bir hata oluştu. Sayfayı yenileyin — sorun devam ederse destek ekibimizle iletişime geçin.",
    "found.reload": "Sayfayı yenile",
    "found.goHome": "Ana sayfaya git",
    "found.goBack": "Geri dön",
    "found.errorDetails": "Teknik detaylar",
    "found.notFoundTitle": "Bu sayfa çalma listesinde yok",
    "found.notFoundDesc": "Aradığınız sayfa mevcut değil veya taşınmış.",

    "found.heroEyebrow": "Müzik dağıtımı",
    "found.heroTitle": "Müziğin, her yerde.",
    "found.heroSubtitle": "Spotify, Apple Music, YouTube, TikTok ve 150+ platformda yayınla. Telif gelirlerini takip et, smart link oluştur ve kitleni büyüt — hepsi tek yerde.",
    "found.platforms": "150+ platform",
    "found.terms": "Şartlar",
    "found.privacy": "Gizlilik",
    "found.support": "Destek",
    "found.rights": "Tüm hakları saklıdır.",
    "found.secure": "Güvenli, şifreli bağlantı",
    "found.welcomeBack": "Tekrar hoş geldin",
    "found.loginSubtitle": "Yayınlarını ve kazançlarını yönetmek için giriş yap.",
    "found.showPassword": "Şifreyi göster",
    "found.hidePassword": "Şifreyi gizle",
    "found.language": "Dil",

    "found.createTitle": "Hesabını oluştur",
    "found.createSubtitle": "EAM Music'e katıl, dakikalar içinde yayına başla.",
    "found.stepAccount": "Hesap",
    "found.stepDetails": "Detaylar",
    "found.stepOf": "Adım {n} / 2",
    "found.continue": "Devam et",
    "found.back": "Geri",
    "found.pwWeak": "Zayıf",
    "found.pwFair": "Orta",
    "found.pwGood": "İyi",
    "found.pwStrong": "Güçlü",
    "found.pwStrength": "Şifre gücü",
    "found.pwHint": "Büyük-küçük harf, rakam ve sembol içeren en az 8 karakter kullanın.",
    "found.pwTooShort": "Şifre en az 6 karakter olmalıdır",
    "found.fillRequired": "Lütfen tüm zorunlu alanları doldurun",
    "found.invalidEmail": "Lütfen geçerli bir e-posta adresi girin",
    "found.termsRequired": "Lütfen Hizmet Şartları'nı ve Gizlilik Politikası'nı kabul edin",
    "found.registerSuccess": "Kayıt başarılı! Hesabınız onay bekliyor.",
    "found.registerFailed": "Kayıt başarısız",
    "found.agreePrefix": "Şunları kabul ediyorum:",
    "found.termsOfService": "Hizmet Şartları",
    "found.and": "ve",
    "found.privacyPolicy": "Gizlilik Politikası",
    "found.addressOptional": "Adres (isteğe bağlı)",
    "found.labelNamePh": "Plak şirketinizin adı",
    "found.labelDescPh": "Şirketinizi kısaca tanıtın…",
    "found.streetPh": "Sokak / cadde adresi",
    "found.cityPh": "Şehir",
    "found.countryPh": "Ülke",
    "found.firstNamePh": "Adınız",
    "found.lastNamePh": "Soyadınız",
    "found.close": "Kapat",
    "found.legalTitle": "Hizmet Şartları ve Gizlilik",
    "found.legalIntro": "Temel maddelerin özeti. Sözleşmenin tam metni dağıtım sözleşmenizle birlikte iletilir; sorularınız için support@eammusic.net adresine yazın.",
    "found.legal1": "EAM Music üzerinden dağıttığınız içeriklerin (master, eser, kapak görseli) tüm haklarına sahip olduğunuzu veya bunları kontrol ettiğinizi beyan edersiniz.",
    "found.legal2": "Yayınlar mağazalara gönderilmeden önce incelenir. Üçüncü kişilerin haklarını ihlal eden, yapay dinlenme içeren veya mağaza politikalarına aykırı içerikler reddedilebilir ya da kaldırılabilir.",
    "found.legal3": "Telif gelirleri mağazalar tarafından raporlandıktan sonra hesabınıza yansıtılır ve panelinizde belirtilen ödeme koşullarına göre çekilebilir.",
    "found.legal4": "Kişisel verilerinizi (ad, iletişim, ödeme ve vergi bilgileri) yalnızca hizmeti sunmak, yasal yükümlülükleri yerine getirmek ve size ödeme yapmak için işleriz. Verilerinizi asla satmayız.",
    "found.legal5": "Verilerinizin bir kopyasını veya silinmesini istediğiniz zaman support@eammusic.net adresine e-posta göndererek talep edebilirsiniz.",

    "found.pendingHello": "Merhaba {name},",
    "found.pendingHelloAnon": "Merhaba,",
    "found.pendingTitle": "Hesabın inceleniyor",
    "found.pendingDesc": "EAM Music'e katıldığın için teşekkürler! Portala erişebilmen için hesabının bir yönetici tarafından onaylanması gerekiyor.",
    "found.pendingNext": "Sırada ne var?",
    "found.pendingStep1": "Ekibimiz her başvuruyu tek tek inceler.",
    "found.pendingStep2": "Hesabın onaylanır onaylanmaz e-posta ile bilgilendirileceksin.",
    "found.pendingStep3": "Ardından ilk yayınını yükleyip 150+ platforma ulaşabilirsin.",
    "found.checkStatus": "Durumu kontrol et",
    "found.statusApproved": "Hesabınız onaylandı!",
    "found.statusRejected": "Başvurunuz reddedildi. Lütfen destek ekibiyle iletişime geçin.",
    "found.statusPending": "Hesabınız hâlâ onay bekliyor.",
    "found.statusFailed": "Durum kontrol edilemedi",
    "found.logout": "Çıkış yap",
  },
  es: {
    "found.loading": "Cargando…",
    "found.errorTitle": "Algo salió mal",
    "found.errorDesc": "Se produjo un error inesperado. Recarga la página; si el problema continúa, contacta con nuestro equipo de soporte.",
    "found.reload": "Recargar página",
    "found.goHome": "Ir al inicio",
    "found.goBack": "Volver",
    "found.errorDetails": "Detalles técnicos",
    "found.notFoundTitle": "Esta página no está en la lista",
    "found.notFoundDesc": "La página que buscas no existe o ha sido movida.",

    "found.heroEyebrow": "Distribución musical",
    "found.heroTitle": "Tu música, en todas partes.",
    "found.heroSubtitle": "Publica en Spotify, Apple Music, YouTube, TikTok y más de 150 plataformas. Controla tus regalías, crea smart links y haz crecer tu audiencia, todo en un solo lugar.",
    "found.platforms": "150+ plataformas",
    "found.terms": "Términos",
    "found.privacy": "Privacidad",
    "found.support": "Soporte",
    "found.rights": "Todos los derechos reservados.",
    "found.secure": "Conexión segura y cifrada",
    "found.welcomeBack": "Bienvenido de nuevo",
    "found.loginSubtitle": "Inicia sesión para gestionar tus lanzamientos y ganancias.",
    "found.showPassword": "Mostrar contraseña",
    "found.hidePassword": "Ocultar contraseña",
    "found.language": "Idioma",

    "found.createTitle": "Crea tu cuenta",
    "found.createSubtitle": "Únete a EAM Music y empieza a publicar en minutos.",
    "found.stepAccount": "Cuenta",
    "found.stepDetails": "Detalles",
    "found.stepOf": "Paso {n} de 2",
    "found.continue": "Continuar",
    "found.back": "Atrás",
    "found.pwWeak": "Débil",
    "found.pwFair": "Aceptable",
    "found.pwGood": "Buena",
    "found.pwStrong": "Fuerte",
    "found.pwStrength": "Seguridad de la contraseña",
    "found.pwHint": "Usa 8+ caracteres con mayúsculas y minúsculas, un número y un símbolo.",
    "found.pwTooShort": "La contraseña debe tener al menos 6 caracteres",
    "found.fillRequired": "Completa todos los campos obligatorios",
    "found.invalidEmail": "Introduce un correo electrónico válido",
    "found.termsRequired": "Acepta los Términos del servicio y la Política de privacidad",
    "found.registerSuccess": "¡Registro completado! Tu cuenta está pendiente de aprobación.",
    "found.registerFailed": "Error en el registro",
    "found.agreePrefix": "Acepto los",
    "found.termsOfService": "Términos del servicio",
    "found.and": "y la",
    "found.privacyPolicy": "Política de privacidad",
    "found.addressOptional": "Dirección (opcional)",
    "found.labelNamePh": "Nombre de tu sello",
    "found.labelDescPh": "Breve descripción de tu sello…",
    "found.streetPh": "Dirección",
    "found.cityPh": "Ciudad",
    "found.countryPh": "País",
    "found.firstNamePh": "Nombre",
    "found.lastNamePh": "Apellido",
    "found.close": "Cerrar",
    "found.legalTitle": "Términos del servicio y privacidad",
    "found.legalIntro": "Resumen de los puntos clave. El acuerdo completo se entrega con tu contrato de distribución; para cualquier duda escribe a support@eammusic.net.",
    "found.legal1": "Confirmas que posees o controlas todos los derechos (máster, composición, portada) del contenido que distribuyes a través de EAM Music.",
    "found.legal2": "Los lanzamientos se revisan antes de su envío. El contenido que infrinja derechos de terceros, use reproducciones artificiales o incumpla las políticas de las tiendas puede ser rechazado o retirado.",
    "found.legal3": "Las regalías se abonan en tu cuenta cuando las tiendas las reportan y pueden retirarse según las condiciones de pago indicadas en tu panel.",
    "found.legal4": "Tratamos tus datos personales (nombre, contacto, datos de pago y fiscales) solo para prestar el servicio, cumplir obligaciones legales y pagarte. Nunca vendemos tus datos.",
    "found.legal5": "Puedes solicitar una copia o la eliminación de tus datos en cualquier momento escribiendo a support@eammusic.net.",

    "found.pendingHello": "Hola {name},",
    "found.pendingHelloAnon": "Hola,",
    "found.pendingTitle": "Tu cuenta está en revisión",
    "found.pendingDesc": "¡Gracias por unirte a EAM Music! Un administrador debe aprobar tu cuenta antes de que puedas acceder al portal.",
    "found.pendingNext": "¿Qué sigue?",
    "found.pendingStep1": "Nuestro equipo revisa cada solicitud manualmente.",
    "found.pendingStep2": "Recibirás un correo en cuanto tu cuenta sea aprobada.",
    "found.pendingStep3": "Después podrás subir tu primer lanzamiento y llegar a más de 150 plataformas.",
    "found.checkStatus": "Comprobar estado",
    "found.statusApproved": "¡Tu cuenta ha sido aprobada!",
    "found.statusRejected": "Tu solicitud ha sido rechazada. Contacta con soporte.",
    "found.statusPending": "Tu cuenta sigue pendiente de aprobación.",
    "found.statusFailed": "No se pudo comprobar el estado",
    "found.logout": "Cerrar sesión",
  },
};

export default foundation;
